import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { VenueDetail } from "./types";
import { VENUE_DETAIL_QUERY_KEY } from "./constants";

/**
 * Hits `GET /api/admin/venues/:id` (API-1.18) — the admin detail
 * endpoint that returns the full record regardless of status (unlike
 * `public/venues/:id`, which is active-only and strips admin fields).
 * Hand-written `httpClient` call — see CLAUDE.md → TD-07.
 */
async function fetchVenueDetail(id: string): Promise<VenueDetail> {
  return httpClient<VenueDetail>(`/api/admin/venues/${encodeURIComponent(id)}`);
}

export function useVenueDetail(id: string | undefined) {
  return useQuery({
    queryKey: [...VENUE_DETAIL_QUERY_KEY, id] as const,
    queryFn: () => {
      if (!id) throw new Error("useVenueDetail requires an id");
      return fetchVenueDetail(id);
    },
    enabled: Boolean(id),
    staleTime: 30_000,
  });
}
